import { render, staticRenderFns } from "./Redoc.vue?vue&type=template&id=1cf051a3&scoped=true"
import script from "./Redoc.vue?vue&type=script&lang=js"
export * from "./Redoc.vue?vue&type=script&lang=js"
import style0 from "./Redoc.vue?vue&type=style&index=0&id=1cf051a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf051a3",
  null
  
)

export default component.exports